
export class OptionByIdRequest {
    selectFrom: string;
    optionIds: string[];

    constructor( selectFrom: string, optionIds: string[] ) {
        this.selectFrom = selectFrom;
        this.optionIds = optionIds;
    }
}
